import DeleteIcon from "../../images/icon_delete.svg";
import DownloadIcon from "../../images/icon_download.svg";
import PDFIcon from "../../images/icon_pdf.svg";
import UploadIcon from "../../images/icon_upload_file.svg";
import { API } from "../../utils/api";
import { FILE_FORMATS } from "../../utils/constants";
import { HTTP_METHODS } from "../../utils/constants";
import FileDropArea from "../FileDropArea/FileDropArea";
import {
  DashedRow,
  FileInfo,
  FilesList,
  RowContainer,
} from "./AdminComplaintFileUploadStyles";

const MAX_FILES = 1;

function AdminComplaintFileUpload(props) {
  const { onValueChange, value, formats, currentFile, onCurrentFileChange } =
    props;
  const appendFile = (addedFile) => {
    onValueChange(addedFile);
    onCurrentFileChange(null);
  };
  const removeFile = () => {
    onValueChange([]);
    onCurrentFileChange(null);
  };
  const handleDownload = (objectName) => {
    generateDownloadUrl(objectName).then((url) => {
      window.open(url, "_blank");
    });
  };
  return (
    <div>
      {value.length === MAX_FILES || currentFile ? (
        <FilesList>
          <FileInfo>
            <div>
              <img src={PDFIcon} alt="PDFIcon" />
              <p>
                {value.length === MAX_FILES
                  ? value[0].name
                  : currentFile.slice(currentFile.lastIndexOf("/") + 1)}
              </p>
            </div>
            <div className="icons">
              {currentFile && (
                <img
                  className="download-icon"
                  src={DownloadIcon}
                  alt="DownloadIcon"
                  onClick={() => handleDownload(currentFile)}
                />
              )}
              <img
                className="delete-icon"
                src={DeleteIcon}
                alt="DeleteIcon"
                onClick={() => removeFile()}
              />
            </div>
          </FileInfo>
        </FilesList>
      ) : (
        <RowContainer>
          <FileDropArea
            onDrop={appendFile}
            formats={formats || [FILE_FORMATS.PDF, FILE_FORMATS.IMAGE]}
          >
            <DashedRow>
              <img src={UploadIcon} alt="UploadIcon" />
              Toca para subir un documento
            </DashedRow>
          </FileDropArea>
        </RowContainer>
      )}
    </div>
  );
}

export default AdminComplaintFileUpload;

function generateDownloadUrl(id) {
  const url = `${
    API.COMPLAINTS.URL
  }/presigned/download?object_name=${encodeURIComponent(id)}`;
  return fetch(url, {
    method: HTTP_METHODS.GET,
    headers: {
      accept: "*/*",
      "Content-Type": "application/json",
    },
  })
    .then((response) => {
      if (response.ok) return response;
      throw response;
    })
    .then((response) => response.json())
    .then((response) => response.message.url)
    .catch((eResponse) => {
      // TODO: The server may return an error object,
      // and is converted using .json. Review this later
      return eResponse.json().then((data) => {
        const error = { ...data, status: eResponse.status };
        throw error;
      });
    });
}
